module.exports = __webpack_public_path__ + "static/img/img-p1-6gs.e9799257.jpg";